module.exports = __webpack_public_path__ + "img/q7.81cd9b72.jpg";